// extracted by mini-css-extract-plugin
module.exports = {"emptyMessage":"emptyMessage_emptyMessage__1tM1y","image":"emptyMessage_image__2n3TS","content":"emptyMessage_content__1VWuX","vertical":"emptyMessage_vertical__3JAlR"};